var initialState = {
  accountStatus: false,
  interestPayments: [],
  conversionRates: {},
  interestRates: {}
};
var parseRates = function parseRates(obj) {
  return Object.values(obj).reduce(function (acc, el) {
    acc[el.ProductId] = el;
    return acc;
  }, {});
};
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case 'UPDATE_INTEREST_ACCOUNT_STATUS':
      return Object.assign({}, state, {
        accountStatus: payload
      });
    case 'RECEIVE_INTEREST_PAYMENTS':
      return Object.assign({}, state, {
        interestPayments: payload
      });
    case 'GET_CONVERSION_RATES':
      return Object.assign({}, state, {
        conversionRates: payload
      });
    case 'GET_INTEREST_RATES':
      return Object.assign({}, state, {
        interestRates: parseRates(payload)
      });
    default:
      return state;
  }
}